import React from 'react';
import PropTypes from 'prop-types';

const PublicFooter = ({ page, partnerName, onLogin }) => (
  <footer id="footer" className={page.type && page.type.toLowerCase()}>
    <div className="footer">
      <div className="footer-accent-left" />
      <div className="footer-accent-right" />
      <div className="container">
        <div className="made-with-love text-center visible-xs visible-sm">
          Made with love by Zola.
        </div>
        <div className="footer-nav">
          <div className="logo-wrapper">
            <div className="logo" />
          </div>
          <div className="nav-wrapper">
            <ul className="list-inline">
              <li>
                <a href="/about" target="_blank" rel="noopener noreferrer">
                  About Zola
                </a>
              </li>
              <li>
                <a
                  href="https://help.zola.com/hc/categories/115000284811-For-Wedding-Guests"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Guest Help
                </a>
              </li>
              <li>
                <a role="button" onClick={onLogin}>
                  My Website
                </a>
              </li>
              <li>1 (408) 657-ZOLA</li>
            </ul>
            <span className="text-muted tos">
              <span>&copy; {new Date().getFullYear()} Zola, Inc. All rights reserved. </span>
              <br className="visible-xs visible-sm visible-md" />
              <span>
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                /{' '}
              </span>
              <span>
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms of Use
                </a>
              </span>
              <span className="hidden-xs"> / </span>
              <br className="visible-xs" />
              <span>
                <a href="/webaccessibility" target="_self">
                  Web Accessibility
                </a>{' '}
                /{' '}
              </span>
              <span>
                <a href="/privacy#CA-privacy-rights" target="_blank" rel="noopener noreferrer">
                  Your CA Privacy Rights
                </a>
              </span>
            </span>
            {partnerName && (
              <span className="text-muted tos">
                <br />
                Designed by {partnerName}
              </span>
            )}
          </div>
        </div>
        <div className="made-with-love pull-right hidden-xs hidden-sm">Made with love by Zola.</div>
      </div>
    </div>
  </footer>
);

PublicFooter.propTypes = {
  page: PropTypes.shape({
    type: PropTypes.string,
  }),
  partnerName: PropTypes.string,
  onLogin: PropTypes.func,
};

export default PublicFooter;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/PublicFooter.jsx